import React, { useState } from "react";
import { Form } from "./interfaces/form";
import * as primitives from "./primitives";
import Container from "../Common/Container";
import Text from "../Common/Text";
import Button from "../primitives/Button";
const Form = ({
  data,
  onSubmit,
  onChange,
}: {
  data: Form;
  onSubmit: (body: any, config: any) => void;
  onChange?: (value: any, id: string) => void;
}) => {
  const [form, setForm] = useState<any>({});
  const [errors, setErrors] = useState<any>({});

  const handleChange = (value: string, id: string) => {
    setForm((old: any) => ({ ...old, [id]: value }));
  };

  const handleSubmit = () => {
    data?.form.forEach((element) => {
      if (!element.optional && !form[element.name]) {
        setErrors((old: any) => ({ ...old, [element.name]: "Obligatorio" }));
      } else {
        setErrors((old: any) => ({ ...old, [element.name]: undefined }));
      }
    });

    onSubmit?.(form, data);
  };
  return (
    <Container className="my-10">
      <Text
        editor={!!onChange}
        id="Form"
        onChange={(val) => {
          onChange?.(val, "title");
        }}
      >
        {data?.title}
      </Text>
      <form onSubmit={(e) => e.preventDefault()} noValidate>
        <div className="grid grid-flow-row-dense grid-cols-2 grid-rows-2 gap-5 mt-5">
          {data?.form?.map((item) => {
            const DynamicComponent =
              primitives.keys[item.type as "Texto" | "Area de texto"];

            if (DynamicComponent) {
              return (
                <div
                  className={`${item.size !== "50" && "col-span-2"}`}
                  key={item.id}
                >
                  <DynamicComponent
                    key={item.id}
                    name={item.name}
                    placeholder={item.placeholder}
                    options={item.options}
                    optional={item.optional}
                    onChange={handleChange}
                    id={item.name}
                    error={errors[item.name]}
                    value={form[item.name]}
                  />
                </div>
              );
            }
          })}
        </div>

        <Button {...data?.button} onClick={handleSubmit} className="mt-5" />
      </form>
    </Container>
  );
};

export default Form;
